module.exports = __webpack_public_path__ + "img/futuris-logo-full.d9847388.svg";